// extracted by mini-css-extract-plugin
module.exports = {"base":"FallbackPagination_base__6Oq4e"};